import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { brandService } from '../../services/brandService';

export const useGetActiveBrands = () => {
  return useQuery({
    staleTime: Infinity,
    queryKey: [QUERY_KEYS.brand.active_brands],
    queryFn: () =>
      brandService.activeBrands().then(response => {
        const { status, data } = response;
        if (status === 200) {
          return data;
        }
        throw new Error('Fetch failed');
      }),
  });
};
